import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vuelayers/lib/style.css";
import Buefy from "buefy";
var VueScrollTo = require("vue-scrollto");

window.App = Vue;
Vue.use(VueScrollTo);

Vue.use(Buefy, {
  defaultIconPack: "fas"
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
